// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import {
  ParaLink,
  ParaContainer,
  ParaHeader,
  ParaFooter,
  ParaBody,
} from "src/styles/signup";

type Props = {
  joinError: string,
  displayNameError: string,
};

const Error = ({ joinError, displayNameError }: Props) => (
  <ParaContainer>
    <ParaHeader>{i18n.t(k.SOMETHING_WENT_WRONG)}</ParaHeader>
    <ParaBody>
      {joinError || displayNameError}
      <br />
      {i18n.t(k.PLEASE_TRY_CLICKING_ON_THE_INV)}
    </ParaBody>
    <ParaFooter>
      {i18n.t(k.STILL_HAVING_TROUBLES)}{" "}
      <ParaLink
        href="https://www.unifize.com/about-us/#contact-us"
        target="_blank"
      >
        {i18n.t(k.CONTACT_US)}
      </ParaLink>
    </ParaFooter>
  </ParaContainer>
);

export default Error;
